import type { GridProps } from '@mui/material';
import type { PublishedEventListItem, TopMarketTypeDisplay } from '../../@types';
import { usePublishedFeaturedEventCardModel } from '../../hooks/useFeaturedEventCardModel';
import EventCardBase from './EventCardBase';

type EventCardProps = {
  event: PublishedEventListItem;
  topMarketTypes?: TopMarketTypeDisplay[];
} & GridProps;

const EventCard = ({ event, topMarketTypes, ...gridProps }: EventCardProps) => {
  const model = usePublishedFeaturedEventCardModel(event, topMarketTypes);

  return <EventCardBase model={model} {...gridProps} />;
};

export default EventCard;
